import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { PageSkeleton } from "../ui/Skeleton";

// react-router v7 guard. Wrap an element with <UserRoute>...</UserRoute> in
// the <Route element={...} /> position. Renders children only if a regular
// (non-admin) user is authenticated.
// While the session is still loading, `fallback` holds the page's space so
// the footer doesn't jump; pass a skeleton shaped like the guarded page.
const UserRoute = ({ children, fallback = <PageSkeleton /> }) => {
  const { user, isAuthenticated, loading } = useSelector((state) => state.user);
  const location = useLocation();

  if (loading) return fallback;
  if (user && user.role === "user" && isAuthenticated === true) {
    return children;
  }
  return <Navigate to="/users/login" replace state={{ from: location }} />;
};

export default UserRoute;
